import gql from 'graphql-tag'
import { SpaceType } from '../../SpaceTypeSelect/spaceTypeQueries'
import { graphql } from 'react-apollo'

const QUERY = gql`
  query QueryInputParameters {
    beamTypes {
      displayName
      id
    }

    slabTypes {
      id
      type
      model
      height
      weight
    }

    beamConcreteGrades {
      id
      displayName
    }

    beamMaterials {
      id
      displayName
    }

    beamExtras {
      id
      displayName
    }

    executionTypes {
      id
      displayName
    }

    finishingTypes {
      id
      displayName
    }

    fireResistances {
      id
      displayName
    }

    spaceTypes(country: "FI") {
      id
      displayName
    }
  }
`

export type Beam = {
  displayName: string
  id: string
}

export type Slab = {
  span: number
  weight: number
  height: number
  model: string
  type: string
  id: number
}

export type BeamConcreteGrade = {
  id: string
  displayName: string
}

export type BeamMaterial = {
  id: string
  displayName: string
}

export type BeamExtra = {
  id: string
  displayName: string
}

export type FireResistance = {
  id: string
  displayName: string
}

export type Execution = {
  id: string
  displayName: string
}

export type Finishing = {
  id: string
  displayName: string
}

export type FormDataResponse = {
  beamTypes: Beam[]
  slabTypes: Slab[]
  beamConcreteGrades: BeamConcreteGrade[]
  fireResistances: FireResistance[]
  spaceTypes: SpaceType[]
}

export const withFormData = graphql<FormDataResponse>(QUERY, {})



// WEBPACK FOOTER //
// ./src/Components/Workspace/Calculation/formDataQueries.ts